export default __webpack_public_path__ + "static/media/linkedIn.f6213d45.svg";